module.exports = __webpack_public_path__ + "img/circuit2.487ac754.png";